<div
  class="task row justify-content-start"
  [class.task-locked]="itemData.taskLocked || itemData.isBlockedByPrerequisites"
>
  <div
    class="gradient-background"
    [class.cursor-pointer]="isClickable"
    (click)="showTaskSidebar()"
  >
    <div class="gradient-bottom-border"></div>
  </div>
  <div class="text-body text-sub task-status p-0">
    <app-dropdown
      [closedHeaderTemplate]="
        itemData.taskLocked || itemData.isBlockedByPrerequisites
          ? blockedStatus
          : null
      "
      [locked]="
        !itemData.canChangeStatus ||
        itemData.taskLocked ||
        itemData.isBlockedByPrerequisites ||
        itemData.taskStatusId === TaskStatusEnum.completed
      "
      (onSelectionChange)="changeStatus($event.value, itemData.id)"
      (borderColorChanged)="borderChanged($event.color, itemData)"
      [startAction]="changeTaskStatus"
      [successAction]="changeTaskStatus_Success"
      [failureAction]="changeTaskStatus_Failure"
      [actionIdentifier]="itemData.id"
      [actionIdentifierKey]="'taskId'"
      [formControl]="statusFormControl"
      [options]="statusDropdownOptions"
    >
      <ng-template #blockedStatus>
        <div class="task-status-header">
          @if ((itemData.isBlockedByPrerequisites || itemData.taskLocked || itemData.isBlockedByPrerequisites) && itemData.taskStatusId !== TaskStatusEnum.completed) {
            <span class="text-body">{{ "TASKS.STATUS_BLOCKED" | translate }}</span>
          } @else {
            <span class="text-body">{{ statusFormControl.value.label }}</span>
          }
          @if (itemData.taskStatusId !== TaskStatusEnum.completed) {
            <svg-icon
              [fill]="'var(--color-text-locked)'"
              [matTooltip]="
                (itemData.isBlockedByPrerequisites
                  ? 'TASKS.TASK_BLOCKED_BY_PREREQUISITES'
                  : 'TASKS.TASK_BLOCKED_MISSING_SOLUTION_SOLUTIONS'
                ) | translate
              "
              matTooltipPosition="right"
              matTooltipShowDelay="200"
              matTooltipClass="light-tooltip"
              name="warning-circle"
            ></svg-icon>
          }
        </div>
      </ng-template>
    </app-dropdown>
  </div>
  <div
    class="task-priority px-0 d-flex justify-content-start align-items-center"
  >
    <div class="gradient-circle gradient-circle-{{ status }}"></div>
    <span class="text-body text-sub">{{ status | titlecase }}</span>
  </div>
  <div
    class="text-body col task-name text-cut align-items-center d-flex gap-2 p-0"
    [title]="itemData.name"
  >
    <svg-icon
      [fill]="
        itemData.taskLocked || itemData.isBlockedByPrerequisites
          ? 'var(--color-text-locked)'
          : 'var(--color-white-text)'
      "
      [name]="itemData.isRecurring ? 'recurring-task' : 'regular-task'"
    ></svg-icon>
    <span class="text-truncate">{{ itemData.name }}</span>
  </div>
  <span
    class="text-body text-sub task-date p-0"
    [class.text-red]="
      itemData.implementationTimeline === ImplementationTimelineEnum.overdue
    "
    [title]="itemData.dueBy | momentPipe: 'DD/MM/YYYY HH:mm A'"
  >
    {{ itemData.dueBy | momentPipe: "DD/MM/YYYY" }}
  </span>
  <div class="text-body text-sub task-domain d-flex align-items-center p-0">
    <span class="text-truncate flex-grow-1">{{
        itemData.domains.length ? itemData.domains[0].domainName : "-"
      }}</span>
    @if (itemData.domains.length > 1) {
      <span class="domains-count d-flex align-items-center">
        +{{ itemData.domains.length - 1 }}
        <svg-icon
          [color]="
            itemData.taskLocked || itemData.isBlockedByPrerequisites
              ? 'var(--color-text-locked)'
              : 'var(--color-white-text)'
          "
          name="multiple-links"
        ></svg-icon>
      </span>
    }
  </div>
  <div class="text-body text-sub task-assetName text-truncate p-0">
    {{ itemData.asset.name }}
  </div>

  <div class="text-body task-owner text-sub text-cut p-0">
    <div class="d-flex justify-content-between">
      <div class="row col m-0 justify-content-between">
        <div class="p-0 col-auto d-flex align-items-center">
          <div
            [style.background-color]="circleColor"
            class="owner-colored-circle"
          ></div>
          <span class="d-flex justify-content-start text-cut">
            {{ itemData.ownerName }}
          </span>
        </div>
        @if (itemData.raci.departments.owner?.[0]?.name) {
          <div class="p-0 col-auto">
            ({{ itemData.raci.departments.owner![0]!.name }})
          </div>
        }
      </div>
      <div class="roles-count d-flex justify-content-end">
        @if (itemData.allDepartments.length === 1) {
          <svg-icon
            [fill]="
              itemData.taskLocked || itemData.isBlockedByPrerequisites
                ? 'var(--color-text-locked)'
                : 'var(--color-white-text)'
            "
            name="user-outline"
          ></svg-icon>
        } @else if (itemData.allDepartments.length >= 1) {
          <div class="col-auto">
            +<span class="roles-count-number">{{
              itemData.allDepartments.length - 1
            }}</span>
          </div>
          <svg-icon
            [fill]="
              itemData.taskLocked || itemData.isBlockedByPrerequisites
                ? 'var(--color-text-locked)'
                : 'var(--color-white-text)'
            "
            class="user-fill-icon"
            name="user-filled"
          ></svg-icon>
        }
      </div>
    </div>
  </div>
  @if (showOutputModal) {
    <div #outputModalBox class="comment-box task-output-box">
      <div class="comment-box-header">
        <span class="comment-box-header-title">
          {{ outputPromptLabel }}
        </span>
      </div>
      <div class="comment-box-header task-output-box-body">
        <textarea
          [formControl]="outputTextControl"
          [placeholder]="'TASKS.OUTPUT_PLACEHOLDER' | translate"
        ></textarea>
      </div>
      <div class="comment-box-actions">
        <app-button
          (buttonClick)="cancelOutputModal()"
          [size]="'slim'"
          [type]="'button'"
        >
          {{ "BUTTON.CANCEL" | translate }}
        </app-button>
        <app-button
          (buttonClick)="confirmOutputModal()"
          [disabled]="outputTextControl.invalid"
          [size]="'slim'"
          [type]="'button'"
        >
          {{ "BUTTON.APPROVE" | translate }}
        </app-button>
      </div>
    </div>
  }
</div>
